import { dataSources } from "./../../../constants/LandingSection";
import { addConversation, fetchModes, fetchProjectById, getChatHistory, getCWUser, listConversations, updateChatHistory, validateUserWithProject, } from "@/core/api/api";
import useToastStore from "../../zustand/toastStore";
import useProjectStore from "../../zustand/projectManagementStore";
import useAuthStore from "@/shared/zustand/authStore";
import { useMainLayoutStore } from "@/shared/zustand/mainLayoutStore";
import { defaultAutoModeOption, HOST_MODES } from "@/constants";
import { isStreamingMessageArray } from "../helpers";
export const initializeChat = async (props) => {
    const { navigate, searchParams, setProjectIdFromURL, chatId, 
    // setActiveStep,
    setOnboardingStep, chatIdRef, setStreamingMessages, triggerForArtifact, setInitLoading, setProjectAccess, setInvalidProject, } = props;
    const { isLoggedIn, user, onboardingStep } = useAuthStore.getState();
    const { showToast } = useToastStore.getState();
    const { selectedProject, setSelectedProject, setShowProjectPage, navigationHistory, } = useProjectStore.getState();
    const { setModesHistory, setCurrentHostMode, setActiveMode, setRecentConversations, setIsUserOnboarded, } = useMainLayoutStore.getState();
    if (!isLoggedIn) {
        navigate("/login");
        return;
    }
    let isRedirecting = false;
    try {
        // First check onboarding status
        const { status: isOnboardingDone, conversations } = await fetchOnboardingStatus(user?.email || "");
        // console.log("isOnboardingDone", isOnboardingDone);
        // console.log("conversations", conversations);
        if (conversations?.length > 0)
            setRecentConversations(conversations);
        // console.log("onboardingStep in initializeChat: ", onboardingStep);
        // old code
        // setIsUserOnboarded(
        //   (isOnboardingDone && user?.provider?.scope) ?? onboardingStep === "done"
        //     ? true
        //     : false
        // );
        // new code
        setIsUserOnboarded(isOnboardingDone);
        const exisitingProjectId = searchParams.get("projectId");
        const artifactId = searchParams.get("artifactId");
        if (exisitingProjectId) {
            // console.log("Found projectId in URL:", exisitingProjectId);
            // setProjectIdFromURL(exisitingProjectId); // for breadcrumbs updation // commented this as its used below
            // first check whether the projectId is valid or not
            setInvalidProject(null); // resetting the state
            const validProjectRes = await fetchProjectById(exisitingProjectId);
            if (validProjectRes.error) {
                setInvalidProject("invalid");
                console.error("Error fetching project info", validProjectRes.error);
                showToast("warn", "Warn", "Invalid project");
                return;
            }
            else {
                setInvalidProject("valid");
            }
            // validation whether the user has access to the project
            if (!user || !user.email) {
                console.warn("User not logged in");
                showToast("warn", "Warn", "User not logged in");
                return;
            }
            if (!exisitingProjectId) {
                console.warn("exisitingProjectId not found");
                showToast("warn", "Warn", "exisitingProjectId not found");
                return;
            }
            setProjectAccess(null);
            const validationRes = await validateUserWithProject(user.email, exisitingProjectId);
            if (validationRes.error) {
                console.error("Error validating user project access", validationRes.error);
                showToast("error", "Error", validationRes.error.errorMessage);
                return;
            }
            if (validationRes.responseData &&
                validationRes.responseData.role &&
                validationRes.responseData.role.length > 0) {
                console.log("responseData.role[0].role", validationRes.responseData.role[0].role);
                const checkFlag = (validationRes.responseData.role[0].role === "owner" ||
                    validationRes.responseData.role[0].role === "editor" ||
                    validationRes.responseData.role[0].role === "viewer");
                if (!checkFlag) {
                    setProjectAccess("denied");
                    setProjectIdFromURL(""); // empty for breadcrumbs 
                    console.warn("User does not have access to the project");
                    showToast("warn", "Warn", "User does not have access to the project");
                    return;
                }
                setProjectAccess("granted");
                setProjectIdFromURL(exisitingProjectId); // for breadcrumbs updation
            }
            else {
                setProjectAccess("denied");
                setProjectIdFromURL(""); // empty for breadcrumbs 
                console.warn("User does not have access to the project");
                showToast("warn", "Warn", "User does not have access to the project");
                return;
            }
        }
        // Check if user explicitly requested a new chat
        const newChatRequested = searchParams.get("newChat") === "true";
        // when no chatId , no projectId and no artifactId and then only open the recent conversation
        if (!chatId &&
            !exisitingProjectId &&
            !artifactId &&
            conversations?.length > 0 &&
            !newChatRequested &&
            conversations[0]) {
            // console.log(
            //   "No chatId in URL, redirecting to most recent chat:",
            //   conversations[0]
            // );
            const urlParams = new URLSearchParams(window.location.search);
            if (exisitingProjectId) {
                urlParams.set("projectId", exisitingProjectId);
            }
            // Remove the newChat parameter if it exists
            urlParams.delete("newChat");
            try {
                // const updates = JSON.parse(conversations[0]);
                const updates = conversations[0];
                const chatIdFromJson = updates["chat_id"];
                if (chatIdFromJson) {
                    isRedirecting = true;
                    // Create a new object without chat_id
                    const updatesWithoutChatId = {};
                    Object.entries(updates)?.forEach(([key, value]) => {
                        if (key !== 'chat_id' && value !== null && value?.trim() !== '') {
                            updatesWithoutChatId[key] = value;
                        }
                    });
                    // Build the complete URL
                    const baseUrl = `/chat/${chatIdFromJson}`;
                    let finalUrl = baseUrl;
                    // Add existing query parameters
                    const queryParams = new URLSearchParams(urlParams);
                    // Add additional parameters from the new object
                    Object.entries(updatesWithoutChatId)?.forEach(([key, value]) => {
                        // Convert snake_case to camelCase if needed
                        const paramKey = key === "artifact_id" ? "artifactId" :
                            key === "project_id" ? "projectId" : key;
                        queryParams.set(paramKey, value);
                    });
                    // console.log("printing  updatesWithoutChatId",updatesWithoutChatId)
                    // Append query parameters if any exist
                    const queryString = queryParams.toString();
                    if (queryString) {
                        finalUrl = `${baseUrl}?${queryString}`;
                    }
                    window.location.href = finalUrl;
                    return;
                }
            }
            catch (error) {
                console.error("Invalid JSON TYPE as its a string", conversations[0]);
                return;
            }
        }
        else if (!chatId && newChatRequested) {
            // console.log("User explicitly requested a new chat");
            // Clear the newChat parameter from URL without reloading
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.delete("newChat");
            // commenting out as now its not needed
            // if (user && user.email) {
            //   // const { responseData, error } = await updateUserChat(user?.email, ""); // old api
            //   const {responseData , error } = await addConversation(user?.email, "", "", ""); // new api
            //   if (error) {
            //     console.error("Error updating user chat", error);
            //     showToast("error", "Error", error.errorMessage);
            //     return;
            //   } else {
            //     // console.log(
            //     //   "Updated user chat with empty as user requested it",
            //     //   responseData
            //     // );
            //   }
            // }
            const newUrl = urlParams.toString()
                ? `/chat?${urlParams.toString()}`
                : "/chat";
            window.history.replaceState(null, "", newUrl);
            // Set up appropriate state for a new chat
            if (isOnboardingDone || onboardingStep === "done") {
                // if (exisitingProjectId) {
                //   const { responseData, error } = await fetchProjectById(
                //     exisitingProjectId
                //   );
                //   if (error) {
                //     console.error("Error fetching project info", error);
                //     showToast("error", "Error", error.errorMessage);
                //   } else {
                //     setSelectedProject(responseData);
                //     setShowProjectPage(true);
                //   }
                // }
                // // Set up Project Mode for a new chat
                // setCurrentHostMode(HOST_MODES["Project Mode"]);
                // setModesHistory([
                //   {
                //     mode: HOST_MODES["Project Mode"],
                //     openedBy: "New Chat",
                //   },
                // ]);
                // setActiveStep(2);
                setOnboardingStep("done");
            }
            else {
                console.warn("9888");
                setOnboardingStep("personas");
                // setActiveStep(0); // Set to appropriate step for new chat for non-onboarded users
            }
        }
        // Then proceed with chat initialization if chatId exists
        else if (chatId) {
            // console.log("Initializing chat with ID:", chatId);
            chatIdRef.current = chatId;
            const { responseData, error } = await getChatHistory(chatId);
            if (error) {
                console.error("Error fetching chat messages", error);
                showToast("error", "Error", error.errorMessage); // commenting this for today
                return;
            }
            if (responseData?.streamingResponse?.streaming_response) {
                if (isStreamingMessageArray(responseData.streamingResponse.streaming_response)) {
                    const messages = responseData.streamingResponse.streaming_response;
                    // console.log("Chat history loaded successfully");
                    setStreamingMessages(messages);
                    const artifactId = searchParams.get("artifactId");
                    if (artifactId) {
                        // console.log("Found artifactId in URL:", artifactId);
                        const messageWithArtifact = messages.find((message) => message.artifactData?.id === artifactId);
                        if (messageWithArtifact?.artifactData) {
                            console.log("Found matching message with artifact data:", messageWithArtifact);
                            // if (isOnboardingDone && user?.provider?.scope) { // old code
                            if (isOnboardingDone) {
                                // If onboarded, first set Project Mode, then the artifact mode
                                setCurrentHostMode(HOST_MODES["Project Mode"]);
                                setModesHistory([
                                    {
                                        mode: HOST_MODES["Project Mode"],
                                        openedBy: "Fully Onboarded",
                                    },
                                    {
                                        mode: messageWithArtifact.artifactData.modeName,
                                        openedBy: `Artifact - ${messageWithArtifact.artifactData.modeName}`,
                                    },
                                ]);
                            }
                            else {
                                // If not onboarded, just set the artifact mode
                                setModesHistory([
                                    {
                                        mode: messageWithArtifact.artifactData.modeName,
                                        openedBy: `Artifact - ${messageWithArtifact.artifactData.modeName}`,
                                    },
                                ]);
                            }
                            // host mode artifact
                            if (messageWithArtifact.artifactData.modeName in HOST_MODES) {
                                setCurrentHostMode(messageWithArtifact.artifactData.modeName);
                                await triggerForArtifact(messageWithArtifact.artifactData, true, true);
                            }
                            // remote mode artifact
                            else {
                                setActiveMode(messageWithArtifact.artifactData.modeName);
                                await triggerForArtifact(messageWithArtifact.artifactData, true, false);
                            }
                        }
                        else {
                            console.warn("No message found with artifactId:", artifactId);
                            showToast("warn", "Warning", "Could not find the specified artifact");
                            // If no matching artifact found, set Project Mode & update the URL
                            // if (isOnboardingDone && user?.provider?.scope) { // old code
                            if (isOnboardingDone) {
                                const currentUrl = window.location.href;
                                const basePath = currentUrl.split("?")[0];
                                window.history.replaceState(null, "", basePath);
                                setCurrentHostMode(HOST_MODES["Project Mode"]);
                                setModesHistory([
                                    {
                                        mode: HOST_MODES["Project Mode"],
                                        openedBy: "Fully Onboarded",
                                    },
                                ]);
                            }
                        }
                    }
                    else if (isOnboardingDone
                    // && // old code
                    // user?.provider?.scope
                    //   ?.split(" ")
                    //   .some((scope) =>
                    //     dataSources.some((source) => source.scope.includes(scope))
                    //   )
                    ) {
                        // If no artifact but onboarded, just set Project Mode
                        if (exisitingProjectId) {
                            const { responseData, error } = await fetchProjectById(exisitingProjectId);
                            if (error) {
                                console.error("Error fetching project info", error);
                                showToast("error", "Error", error.errorMessage);
                            }
                            else {
                                // console.log("responseData of project info is:", responseData);
                                setSelectedProject(responseData);
                                setShowProjectPage(true);
                                // setProjectIdFromURL(exisitingProjectId); // for breadcrumbs updation
                            }
                        }
                        // Always set these up, regardless of project fetch success/failure
                        setCurrentHostMode(HOST_MODES["Project Mode"]);
                        setModesHistory([
                            {
                                mode: HOST_MODES["Project Mode"],
                                openedBy: "Fully Onboarded",
                            },
                        ]);
                    }
                }
                else {
                    showToast("warn", "Warn", "Invalid message format received");
                }
            }
            else {
                console.error("No chat history found for ID:", chatId);
                showToast("warn", "Warn", "No chat history found");
            }
        }
        else if ((isOnboardingDone
        // && // old code
        // user?.provider?.scope
        //   ?.split(" ")
        //   .some((scope) =>
        //     dataSources.some((source) => source.scope.includes(scope))
        //   )
        ) ||
            onboardingStep === "done") {
            if (exisitingProjectId) {
                const { responseData, error } = await fetchProjectById(exisitingProjectId);
                if (error) {
                    console.error("Error fetching project info", error);
                    showToast("error", "Error", error.errorMessage);
                }
                else {
                    // console.log("responseData of project info is:", responseData);
                    setSelectedProject(responseData);
                    setShowProjectPage(true);
                    // setProjectIdFromURL(exisitingProjectId); // for breadcrumbs updation
                }
                // Always set these up, regardless of project fetch success/failure
                setCurrentHostMode(HOST_MODES["Project Mode"]);
                setModesHistory([
                    {
                        mode: HOST_MODES["Project Mode"],
                        openedBy: "Fully Onboarded",
                    },
                ]);
            }
            else
                setOnboardingStep("done"); //setActiveStep(2);
            // If no chatId but onboarded, set Project Mode
            // setCurrentHostMode(HOST_MODES["Project Mode"]);
            // setModesHistory([
            //   {
            //     mode: HOST_MODES["Project Mode"],
            //     openedBy: "Fully Onboarded",
            //   },
            // ]);
        }
        else {
            // setActiveStep(0);
            console.warn("1234");
            setOnboardingStep("personas");
        }
    }
    catch (error) {
        console.error("Error during initialization:", error);
        showToast("error", "Error", "Failed to initialize"); // commenting this for today
    }
    finally {
        // setInitLoading(false);
        // Only set loading to false if we're not redirecting
        if (!isRedirecting) {
            setInitLoading(false);
        }
    }
};
export const updateUserChatAndHistory = async (email, chatId, newMessages) => {
    const showToast = useToastStore.getState().showToast;
    try {
        // Define both promises to be executed
        const urlObject = new URL(window.location.href);
        const urlProjectId = urlObject.searchParams.get("projectId");
        const artifactId = urlObject.searchParams.get("artifactId");
        // console.log("printing--","urlProjectId", urlProjectId,"artifactId", artifactId);
        const chatData = {
            chatId: chatId,
            projectId: urlProjectId ?? null,
            artifactId: artifactId ?? null,
        };
        // const updateUserChatPromise = updateUserChat(
        //   email,
        //   JSON.stringify(chatData)
        // ); // old api
        const addConversationPromise = addConversation(email, chatId, artifactId ?? "", urlProjectId ?? ""); // new api
        const updateChatHistoryPromise = updateChatHistory(chatId, newMessages);
        // Execute both promises concurrently
        const results = await Promise.allSettled([
            // updateUserChatPromise, // old api
            addConversationPromise, // new api
            updateChatHistoryPromise,
        ]);
        // Process the results
        const [userChatResult, chatHistoryResult] = results;
        let hasError = false;
        // Process user chat update result
        if (userChatResult.status === "fulfilled") {
            const { responseData, error } = userChatResult.value;
            if (error) {
                console.error("Error updating user chat", error);
                showToast("error", "Error", error.errorMessage);
                hasError = true;
            }
            else {
                // console.log("Updated user chat", responseData);
            }
        }
        else {
            console.error("Failed to update user chat", userChatResult.reason);
            showToast("error", "Error", "Failed to update user chat");
            hasError = true;
        }
        // Process chat history update result
        if (chatHistoryResult.status === "fulfilled") {
            const { responseData, error } = chatHistoryResult.value;
            if (error) {
                console.error("Error in Updating the chat history", error);
                showToast("error", "Error", error.errorMessage);
                hasError = true;
            }
            else if (responseData) {
                // console.log("Chat history update success", responseData);
            }
        }
        else {
            console.error("Failed to update chat history", chatHistoryResult.reason);
            showToast("error", "Error", "Failed to update chat history");
            hasError = true;
        }
        return !hasError; // Return true if both operations were successful
    }
    catch (error) {
        console.error("Unexpected error during chat updates", error);
        showToast("error", "Error", "An unexpected error occurred");
        return false;
    }
};
export const updateUrlWithParams = (chatId, searchParams, updates) => {
    // Creating a new URLSearchParams object from the current URL
    const currentUrl = new URL(window.location.href);
    const newParams = new URLSearchParams(currentUrl.search);
    // Apply only the specified updates
    Object.entries(updates).forEach(([key, value]) => {
        if (value === null) {
            newParams.delete(key);
        }
        else {
            newParams.set(key, value);
        }
    });
    // Construct the URL while preserving all parameters
    const baseUrl = chatId ? `/chat/${chatId}` : "/chat";
    const queryString = newParams.toString();
    const newUrl = queryString ? `${baseUrl}?${queryString}` : baseUrl;
    // console.log("new URL which gets updated:",newUrl," where updates were",updates);
    window.history.replaceState(null, "", newUrl);
};
export const getModes = async () => {
    const { responseData, error } = await fetchModes();
    const showToast = useToastStore.getState().showToast;
    if (error) {
        console.error("Error fetching modes:", error);
        showToast("error", "Error", error.errorMessage);
        return [defaultAutoModeOption];
    }
    if (responseData) {
        const newList = responseData.map((item) => ({
            modeName: item.modeName,
            description: item.modeDescription,
            modeId: item.modeId,
            url: item.url,
            remote: item.remote,
            module: item.module,
            components: item.components,
        }));
        return [defaultAutoModeOption, ...newList];
    }
};
export const fetchOnboardingStatus = async (userEmail) => {
    const showToast = useToastStore.getState().showToast;
    try {
        let finalStatus = false;
        let finalConversations = [];
        const { responseData, error } = await getCWUser(userEmail); //getUserData(userEmail);
        if (error) {
            showToast("error", "Error", error.errorMessage);
            console.log("error in fetchOnboardingStatus", error, "error message", error.errorMessage);
            console.log("print return", { status: false, conversations: [] });
            // return { status: false, conversations: [] };
            finalStatus = false;
        }
        const conversationResData = await listConversations(userEmail);
        const data = responseData;
        const personaStatus = Boolean(data?.persona && data?.persona?.length > 0);
        const accessStatus = data?.access_scopes?.split(" ")
            .some((scope) => dataSources.some((source) => source.scope.includes(scope)));
        // console.log("printing accessStatus",accessStatus,"personaStatus",personaStatus);
        finalStatus = Boolean(accessStatus) && personaStatus;
        if (conversationResData.error) {
            showToast("error", "Error", conversationResData.error.errorMessage);
            console.log("print return in conversationResData", { status: finalStatus, conversations: [] });
            // return { status: finalStatus, conversations: [] };
            finalConversations = [];
        }
        if (conversationResData?.responseData && "status" in conversationResData?.responseData && conversationResData?.responseData?.status === 404) {
            finalConversations = [];
        }
        // old code for api call
        // const response = await axios.get(
        //   `${process.env.VITE_BASE_API_URL}/user/${userEmail}`,
        //   {
        //     headers: {
        //       "Content-Type": "application/json",
        //     },
        //   }
        // );
        if (!responseData) {
            console.log("print return in responseData", { status: false, conversations: [] });
            // return { status: false, conversations: [] };
            finalStatus = false;
        }
        if (!conversationResData?.responseData) {
            finalConversations = [];
        }
        // if(!responseData.conversations){
        //   console.log("print return in responseData.conversations",{ status: false, conversations: [] });
        //   return { status: false, conversations: [] };
        // }
        // if (
        //   "conversations" in data &&
        //   data["conversations"] &&
        //   data["conversations"]?.length > 0
        // ) {
        //   conversations = data["conversations"];
        // }
        if (conversationResData?.responseData && conversationResData?.responseData?.conversations?.length > 0) {
            finalConversations = conversationResData?.responseData?.conversations;
        }
        // const status =
        //   // Boolean(data?.access_scopes?.length > 1) &&
        //   Boolean(data?.persona?.length > 0);
        // const accessStatus =  data?.access_scopes?.split(" ")
        // .some((scope) =>
        //   dataSources.some((source) => source.scope.includes(scope))
        // )
        // const finalStatus  = accessStatus && status")
        console.log("print return in final return", { status: finalStatus, finalConversations });
        return { status: finalStatus, conversations: finalConversations };
    }
    catch (error) {
        console.error("Failed to fetch onboarding status:", error);
        console.log("print return in error catch", { status: false, conversations: [] });
        return { status: false, conversations: [] };
    }
};
export const updateArtifactIdInUrl = (artifactData, searchParams, setSearchParams) => {
    if (!artifactData?.id) {
        console.warn("Artifact ID not found in artifactData");
        return;
    }
    const urlObject = new URL(window.location.href);
    const pathname = urlObject.pathname;
    const pathSegments = pathname.split("/");
    const chatIdFromUrl = pathSegments[2];
    // Use chatId from URL params or fall back to chatIdRef.current
    const currentChatId = chatIdFromUrl;
    if (!currentChatId) {
        console.warn("No valid chatId found in URL or ref");
        return;
    }
    // Get the existing projectId from the URL
    const existingProjectId = searchParams.get("projectId");
    const storeProjectId = useProjectStore.getState().selectedProject?._id;
    const selectedProject = useProjectStore.getState().selectedProject;
    // Only include projectId in updates if there's an explicitly selected project
    const updates = {
        artifactId: artifactData.id,
    };
    // Add projectId to updates only if:
    // 1. There's a selected project in store/state, OR
    // 2. No projectId exists in URL (maintains backwards compatibility)
    if (storeProjectId || selectedProject?._id || !existingProjectId) {
        updates.projectId = storeProjectId || selectedProject?._id || null;
    }
    // Update URL
    updateUrlWithParams(currentChatId, searchParams, updates);
};
export function generateAccessRequestEmailBody(userName, userEmail, projectId, projectName, baseUrl, ownerEmail) {
    // Generate the grant access URL with all parameters including ownerEmail
    const generateGrantAccessUrl = () => {
        try {
            // Encode all parameters to ensure URL validity
            const params = new URLSearchParams({
                userName: userName,
                userEmail: userEmail,
                projectId: projectId,
                projectName: projectName,
                ownerEmail: ownerEmail,
                action: "grantAccess",
            });
            // Construct the complete URL with base URL and parameters
            return `${baseUrl}/project-access?${params.toString()}`;
        }
        catch (error) {
            console.error("Error generating access URL:", error);
            // Fallback in case of errors
            return `${baseUrl}/project-access`;
        }
    };
    // Generate the grant access button URL
    const grantAccessUrl = generateGrantAccessUrl();
    // console.log("printing grantAccessUrl", grantAccessUrl);
    // Get current year for footer
    const currentYear = new Date().getFullYear();
    return `
    <!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="utf-8" />
        <meta content="width=device-width, initial-scale=1.0" name="viewport" />
        <title>Project Access Request</title>
        <style>
            @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
            
            body {
                font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
                line-height: 1.6;
                color: #374151;
                margin: 0;
                padding: 0;
                background-color: #f3f4f6;
            }
            
            .email-wrapper {
                max-width: 650px;
                margin: 40px auto;
                background-color: #ffffff;
                border-radius: 8px;
                overflow: hidden;
                box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
            }
            
            .brand-header {
                padding: 24px 40px;
                background-color: #ffffff;
                border-bottom: 1px solid #e5e7eb;
            }
            
            .brand-logo {
                max-width: 220px;
                height: auto;
            }
            
            .title-header {
                padding: 24px 40px;
                background-color: #ffffff;
            }
            
            .update-title {
                margin: 0;
                font-size: 24px;
                font-weight: 700;
                color: #111827;
            }
            
            .update-subtitle {
                color: #6366F1;
                font-size: 16px;
                margin: 0 0 6px 0;
                font-weight: 500;
            }
            
            .email-body {
                padding: 24px 40px 36px;
            }
            
            .greeting {
                font-size: 16px;
                margin-bottom: 20px;
            }
            
            .message-container {
                background-color: #f9fafb;
                border-radius: 8px;
                padding: 24px;
                margin: 20px 0 28px;
                border-left: 4px solid #6366F1;
            }
            
            .message-container p {
                margin: 0;
                font-size: 16px;
                color: #1f2937;
                line-height: 1.5;
            }
            
            .highlighted-text {
                font-weight: 600;
                color: #4F46E5;
            }
            
            .action-container {
                text-align: center;
                margin: 32px 0;
            }
            
            .action-button {
              display: inline-block;
              background-color: #4F46E5;
              color: white !important;
              text-decoration: none;
              padding: 12px 32px;
              border-radius: 6px;
              font-size: 16px;
              font-weight: 500;
              letter-spacing: 0.3px;
              transition: all 0.2s ease;
              border: none;
              cursor: pointer;
          }
          
            /* These additional selectors ensure the text stays white in all states */
            .action-button:link,
            .action-button:visited,
            .action-button:hover,
            .action-button:active {
                color: white !important;
            }
          
            .email-meta {
                margin-top: 28px;
                padding-top: 20px;
                border-top: 1px solid #e5e7eb;
            }
            
            .meta-info {
                margin-bottom: 12px;
                font-size: 14px;
                color: #6b7280;
            }
            
            .meta-label {
                font-weight: 600;
                color: #4b5563;
                display: inline-block;
                width: 100px;
                margin-right: 8px;
            }
            
            .help-text {
                margin-top: 24px;
                color: #6b7280;
                font-size: 14px;
            }
            
            .footer {
                padding: 24px 40px;
                text-align: left;
                background-color: #f9fafb;
                border-top: 1px solid #e5e7eb;
            }
            
            .footer-text {
                color: #6b7280;
                font-size: 13px;
                margin: 0;
            }
            
            @media (max-width: 650px) {
                .email-wrapper {
                    margin: 20px;
                    border-radius: 8px;
                }
                
                .brand-header, .title-header, .email-body, .footer {
                    padding-left: 24px;
                    padding-right: 24px;
                }
                
                .update-title {
                    font-size: 22px;
                }
                
                .message-container {
                    padding: 20px;
                }
                
                .action-button {
                    padding: 12px 28px;
                    font-size: 15px;
                    width: 100%;
                    box-sizing: border-box;
                    text-align: center;
                }
                
                .meta-label {
                    width: 90px;
                }
            }
        </style>
    </head>
    
    <body>
        <div class="email-wrapper">
            <div class="brand-header">
              <h2 style="color: #4F46E5; margin: 0; font-weight: 700; font-size: 24px;">Creative Workspace</h2>
            </div>
            
            <div class="title-header">
                <p class="update-subtitle">Project Access Request</p>
                <h1 class="update-title">User Access Authorization</h1>
            </div>
            
            <div class="email-body">
                <p class="greeting">Hi there,</p>
                
                <div class="message-container">
                    <p><span class="highlighted-text">${userName}</span> is requesting access to <span class="highlighted-text">${projectName}</span></p>
                </div>
                
                <div class="action-container">
                    <a href="${grantAccessUrl}" class="action-button">
                        Grant Access
                    </a>
                </div>
                
                <div class="email-meta">
                    <div class="meta-info">
                        <span class="meta-label">User Email:</span>
                        <span>${userEmail}</span>
                    </div>
                </div>
                
                <p class="help-text">If you have any questions, feel free to reach out to us.</p>
            </div>
            
            <div class="footer">
                <p class="footer-text">This is an automated message from Creative WorkSpace. © ${currentYear} Techolution</p>
            </div>
        </div>
    </body>
    </html>
  `;
}
export function createFolderSharingTemplate(ownerName, projectName, openUrl) {
    const currentYear = new Date().getFullYear();
    return `
    <!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="utf-8" />
        <meta content="width=device-width, initial-scale=1.0" name="viewport" />
        <title>Project Shared With You</title>
        <style>
            @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
            
            body {
                font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
                line-height: 1.6;
                color: #374151;
                margin: 0;
                padding: 0;
                background-color: #f3f4f6;
            }
            
            .email-wrapper {
                max-width: 650px;
                margin: 40px auto;
                background-color: #ffffff;
                border-radius: 8px;
                overflow: hidden;
                box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
            }
            
            .brand-header {
                padding: 24px 40px;
                background-color: #ffffff;
                border-bottom: 1px solid #e5e7eb;
            }
            
            .title-header {
                padding: 24px 40px;
                background-color: #ffffff;
            }
            
            .update-title {
                margin: 0;
                font-size: 24px;
                font-weight: 700;
                color: #111827;
            }
            
            .update-subtitle {
                color: #6366F1;
                font-size: 16px;
                margin: 0 0 6px 0;
                font-weight: 500;
            }
            
            .email-body {
                padding: 24px 40px 36px;
            }
            
            .greeting {
                font-size: 16px;
                margin-bottom: 20px;
            }
            
            .message-container {
                background-color: #f9fafb;
                border-radius: 8px;
                padding: 24px;
                margin: 20px 0 28px;
                border-left: 4px solid #6366F1;
            }
            
            .message-container p {
                margin: 0;
                font-size: 16px;
                color: #1f2937;
                line-height: 1.5;
            }
            
            .highlighted-text {
                font-weight: 600;
                color: #4F46E5;
            }
            
            .action-container {
                text-align: center;
                margin: 32px 0;
            }
            
            .action-button {
              display: inline-block;
              background-color: #4F46E5;
              color: white !important;
              text-decoration: none;
              padding: 12px 32px;
              border-radius: 6px;
              font-size: 16px;
              font-weight: 500;
              letter-spacing: 0.3px;
              transition: all 0.2s ease;
              border: none;
              cursor: pointer;
            }
          
            /* These additional selectors ensure the text stays white in all states */
            .action-button:link,
            .action-button:visited,
            .action-button:hover,
            .action-button:active {
                color: white !important;
            }
          
            .folder-info {
                display: flex;
                align-items: center;
                margin-top: 20px;
                background-color: #f9fafb;
                border-radius: 6px;
                padding: 16px;
            }
            
            .folder-icon {
                margin-right: 16px;
                color: #6366F1;
                font-size: 24px;
            }
            
            .folder-name {
                font-weight: 500;
                color: #374151;
                font-size: 16px;
            }
            
            .footer {
                padding: 24px 40px;
                text-align: left;
                background-color: #f9fafb;
                border-top: 1px solid #e5e7eb;
            }
            
            .footer-text {
                color: #6b7280;
                font-size: 13px;
                margin: 0;
            }
            
            @media (max-width: 650px) {
                .email-wrapper {
                    margin: 20px;
                    border-radius: 8px;
                }
                
                .brand-header, .title-header, .email-body, .footer {
                    padding-left: 24px;
                    padding-right: 24px;
                }
                
                .update-title {
                    font-size: 22px;
                }
                
                .message-container {
                    padding: 20px;
                }
                
                .action-button {
                    padding: 12px 28px;
                    font-size: 15px;
                    width: 100%;
                    box-sizing: border-box;
                    text-align: center;
                }
            }
        </style>
    </head>
    
    <body>
        <div class="email-wrapper">
            <div class="brand-header">
              <h2 style="color: #4F46E5; margin: 0; font-weight: 700; font-size: 24px;">Creative Workspace</h2>
            </div>
            
            <div class="title-header">
                <p class="update-subtitle">Folder Access Notification</p>
                <h1 class="update-title">${ownerName} has shared a folder with you</h1>
            </div>
            
            <div class="email-body">
                <p class="greeting">Hi there,</p>
                
                <div class="message-container">
                    <p><span class="highlighted-text">${ownerName}</span> has shared <span class="highlighted-text">${projectName}</span> with you</p>
                </div>
                
                <div class="folder-info">
                    <div class="folder-icon">📁</div>
                    <div class="folder-name">${projectName}</div>
                </div>
                
                <div class="action-container">
                    <a href="${openUrl}" class="action-button">
                        Open
                    </a>
                </div>
                
                <p class="help-text" style="margin-top: 24px; color: #6b7280; font-size: 14px;">If you have any questions, feel free to reach out to the folder owner.</p>
            </div>
            
            <div class="footer">
                <p class="footer-text">This is an automated message from Creative WorkSpace. © ${currentYear} Techolution</p>
            </div>
        </div>
    </body>
    </html>
  `;
}
